import _ from 'lodash'
import React, { useEffect } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import ReactTable from 'react-table'
import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row,
  UncontrolledTooltip,
  Input
} from 'reactstrap'
import { MdModeEdit } from "react-icons/md";

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import CustomPagination from 'components/Pagination'
import SearchForm from 'components/SearchForm'
import PageTitle from 'components/Title/PageTitle'
import { IoIosCloseCircle, IoIosCheckmarkCircle } from "react-icons/io"

import PortalUsersHOC from './actions'
import PortalUsersForm from './EditForm'
import BookingModal from './BookingModal'
import CreateForm from './CreateForm'
import LogContent from './LogContent'
import MediaContent from './MediaContent'
import UploadModalContent from './UploadModalContent'
import TrafficLight from './TrafficLight'
import { StatusOptions } from './assets'

import Lang from 'Lang/General'

const PortalUsers = props => {

  const handleCreateButtonLabel = () => {
    if (props.history.location.pathname.indexOf('consultants') > -1) {
      return 'CREATE_CONSULTANT'
    }

    if (props.history.location.pathname.indexOf('speakers') > -1) {
      return 'CREATE_SPEAKER'
    }

    return 'CREATE_EXHIBITORS'
  }

  useEffect(() => {
    props.getCountries()
    let tmpIndex = _.findIndex(props.data.selectCenterReducer.selectedCenter.center.modules, { name: 'Fair' })
    props.onChangePortalUsersHOC('subscribedPackage', tmpIndex > -1)

    let tempView = 'EXHIBITOR'
    let tempSearch = _.cloneDeep(props.searchParams)

    if (props.history.location.pathname.indexOf('consultants') > -1) {
      tempView = 'CONSULTANT'
    }
    if (props.history.location.pathname.indexOf('speakers') > -1) {
      tempView = 'SPEAKER'
    }
    tempSearch[2].param = [tempView]

    props.getPortalUsers({
      page: 1,
      is_paginated: true,
      filter: {
        "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id,
        "$or": [
          { "role": tempView },
        ]
      }
    })

    props.getFairs()
    props.getIndustries()
    props.onChangePortalUsersHOC('defaultQuery', {
      page: 1,
      is_paginated: true,
      filter: {
        "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id,
        "$or": [
          { "role": tempView },
        ]
      }
    })
    props.onChangePortalUsersHOC('defaultSearchParams', tempSearch)
    props.onChangePortalUsersHOC('searchParams', tempSearch)
    props.onChangePortalUsersHOC('currentView', tempView)
  }, [])

  useEffect(() => {
    if (!props.showCreatePortalUsers && !props.showEditModal) {
      props.onChangePortalUsersHOC('errors', {})
    }
  }, [props.showCreatePortalUsers, props.showEditModal])

  useEffect(() => {
    if (!props.showEditModal) {
      props.onChangePortalUsersHOC('selectedPortalUsers', {})
    }
  }, [props.showEditModal])

  const permissionHandle = (context) => {
    let tmp = _.find(props.data.roleReducer.role.platforms, { name: 'Aciso Cockpit' })
    let tmpModules = {}
    if (tmp) {
      tmpModules = _.find(tmp.modules, { name: 'Fair' })
      return props.subscribedPackage && tmpModules[context]
    }
  }

  const renderCreatePortalUsersForm = () => (
    <Modal isOpen={props.showCreatePortalUsers} size='xl' >
      <CreateForm
        data={props.data}
        errors={props.errors}
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        countries={props.countries}
        industries={props.industries}
        fairs={props.fairs}
        onSubmit={props.createPortalUsers}
        onClose={() => props.onChangePortalUsersHOC('showCreatePortalUsers', false)}
      />
      {props.onLoadPortalUsersHOC && <LoadingOverlay />}
    </Modal>
  )

  const renderLogModal = () => (
    <Modal isOpen={props.showLogModal} size='xl' >
      <LogContent
        {...props}
        onClose={() => {
          props.onChangePortalUsersHOC('showLogModal', false)
          props.onChangePortalUsersHOC('selectedPortalUsers', null)
        }}
      />
      {props.onLoadPortalUsersHOC && <LoadingOverlay />}
    </Modal>
  )

  const renderMediaModal = () => (
    <Modal isOpen={props.showMediaModal} size='xl' >
      <MediaContent
        {...props}
        onClose={() => props.onChangePortalUsersHOC('showMediaModal', false)}
      />
      {props.onLoadPortalUsersHOC && <LoadingOverlay />}
    </Modal>
  )

  const renderUploadContentModal = () => (
    <Modal isOpen={props.showUploadModal} size='xl' >
      <UploadModalContent
        {...props}
        onClose={() => props.onChangePortalUsersHOC('showUploadModal', false)}
      />
      {props.onLoadPortalUsersHOC && <LoadingOverlay />}
    </Modal>
  )

  const renderUpdatePortalUsersForm = () => (
    <Modal isOpen={props.showEditModal} size='xl' >
      <PortalUsersForm
        errors={props.errors}
        updatingConfirmed={props.updatingConfirmed}
        resetPW={props.resetPW}
        countries={props.countries}
        industries={props.industries}
        fairs={props.fairs}
        clientID={props.data.selectCenterReducer.selectedCenter.center.client_id}
        selectedPortalUsers={props.selectedPortalUsers}
        data={props.data}
        onSubmit={props.updatePortalUsers}
        onChangePortalUsersHOC={props.onChangePortalUsersHOC}
        onClose={() => props.onChangePortalUsersHOC('showEditModal', false)}
      />
      {props.onLoadPortalUsersHOC && <LoadingOverlay />}
    </Modal>
  )

  const renderBookingModal = () => {
    return (
      <Modal isOpen={props.selectedBooking !== null} size='xl' >
        <BookingModal
          updateBooking={props.updateBooking}
          data={props.data}
          selectedBooking={props.selectedBooking}
          selectedPortalUsers={props.selectedPortalUsers}
          onClose={() => {
            props.onChangePortalUsersHOC('selectedBooking', null)
            props.onChangePortalUsersHOC('selectedPortalUsers', null)
          }}
        />
        {props.onLoadPortalUsersHOC && <LoadingOverlay />}
      </Modal>
    )
  }

  return (
    <>
      <PageTitle
        heading={Lang[props.currentView][props.data.languageReducer.userSettings.admin_panel_language]}
        icon="pe-7s-user icon-gradient bg-happy-itmeo"
        buttons={[
          {
            buttonText: `${Lang[handleCreateButtonLabel()][props.data.languageReducer.userSettings.admin_panel_language]}`,
            onClick: () => props.onChangePortalUsersHOC('showCreatePortalUsers', true),
            display: permissionHandle('is_create')
          }
        ]}
      />
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Row>
            <Col md={12}>
              <SearchForm
                searchParams={props.searchParams}
                onChangeHOCState={props.onChangePortalUsersHOC}
                defaultSearchParams={props.defaultSearchParams}
                defaultQuery={props.defaultQuery}
                getListAPI={val => {
                  props.getPortalUsers({
                    ...val,
                    filter: {
                      "client_id": props.data.selectCenterReducer.selectedCenter.center.client_id,
                      ...val.filter.status && {
                        "status": val.filter.status
                      },
                      ... val.filter.company_name && {
                        "$or": [
                        { "company_name": val.filter.company_name },
                        { "short_company_name": val.filter.company_name }
                      ]}
                    }
                  })
                }}
              />
            </Col>
            <Col md={12}>
              <Card className='main-card mb-3 p-4' >
                <div className="d-flex align-items-center flex-wrap mb-3" style={{ gap: 10 }}>
                  <Button
                    color={props.isShowingAll ? 'primary' : 'secondary'}
                    onClick={() => {
                      props.getPortalUsers({
                        ...props.query,
                        ...props.isShowingAll ? {
                          is_paginated: true,
                          page: 1
                        } : {
                          is_paginated: false,
                          page: 1
                        }
                      })
                      props.onChangePortalUsersHOC('isShowingAll', !props.isShowingAll)
                    }}
                  >
                    {Lang['SHOW_ALL'][props.data.languageReducer.userSettings.admin_panel_language]}
                  </Button>
                  <div className="d-flex align-items-center ml-auto">
                    <IoIosCheckmarkCircle
                      size={16}
                      className='mr-1 text-success'
                    />
                    <span>{Lang['COMPLETED'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                  </div>
                  <div className="d-flex align-items-center">
                    <IoIosCloseCircle
                      size={16}
                      className='mr-1 text-danger'
                    />
                    <span>{Lang['NOT_YET_FILLED'][props.data.languageReducer.userSettings.admin_panel_language]}</span>
                  </div>
                </div>
                <ReactTable
                  defaultPageSize={10}
                  pageSize={props.isShowingAll ? props.portalUsers.length : 10}
                  showPagination={false}
                  NoDataComponent={() => <span></span>}
                  data={props.portalUsers}
                  columns={[
                    {
                      Header: Lang['COMPANY'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'company_name',
                      Cell: row => (
                        <div>
                          <p className='mb-0'>{row.original.company_name}</p>
                          <i>({row.original.short_company_name})</i>
                        </div>
                      )
                    },
                    {
                      Header: Lang['FAIRS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'start_at',
                      Cell: row => (
                        <div className='d-block'>
                          {
                            _.isEmpty(row.original.fairs) && (
                              <p>-</p>
                            )
                          }
                          {
                            !_.isEmpty(row.original.fairs) &&
                            row.original.fairs.map(fairChild => (
                              <div
                                key={fairChild.id}
                                className='d-flex p-1 align-items-center'
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  props.onChangePortalUsersHOC('selectedPortalUsers', row.original)
                                  props.getSelectedBooking(row.original.id, fairChild.id)
                                }}
                              >
                                <MdModeEdit fontSize={14} />
                                <span className='ml-1'> {fairChild.title}</span>
                              </div>
                            ))
                          }
                        </div>
                      )
                    },
                    {
                      Header: Lang['STATUS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'status',
                      Cell: row => (
                        <Input
                          type={'select'}
                          value={row.original.status}
                          onChange={e => {
                            if (e.target.value !== 'CONFIRMED') {
                              props.updatePortalUsers({
                                ...row.original,
                                fairs: [],
                                status: e.target.value
                              })
                            } else {
                              props.onChangePortalUsersHOC('updatingConfirmed', true)
                              props.onChangePortalUsersHOC('selectedPortalUsers', row.original)
                              props.onChangePortalUsersHOC('showEditModal', true)
                            }
                          }}
                        >
                          {
                            StatusOptions(props.data.languageReducer.userSettings.admin_panel_language).map(child => (
                              <option key={child.value} value={child.value}>{child.label}</option>
                            ))
                          }
                        </Input>
                      )
                    },
                    {
                      Header: Lang['TRAFFIC_LIGHT'][props.data.languageReducer.userSettings.admin_panel_language],
                      Cell: row => (
                        <>
                          <TrafficLight
                            {...props}
                            row={row}
                          />
                        </>
                      )
                    },
                    {
                      Header: Lang['ACTIONS'][props.data.languageReducer.userSettings.admin_panel_language],
                      accessor: 'id',
                      style: {
                        "justify-content": "center"
                      },
                      Cell: row => (
                        <div className='d-flex flex-wrap'>
                          {
                            permissionHandle('is_update') && (
                              <>
                                <Button
                                  className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                                  color='primary'
                                  id={`portal-user-${row.original.id}-edit-btn`}
                                  onClick={() => {
                                    props.onChangePortalUsersHOC('selectedPortalUsers', row.original)
                                    props.onChangePortalUsersHOC('showEditModal', true)
                                  }} >
                                  <i className="pe-7s-pen btn-icon-wrapper" />
                                </Button>
                                <UncontrolledTooltip
                                  target={`portal-user-${row.original.id}-edit-btn`}
                                  placement="top">
                                  {Lang['EDIT'][props.data.languageReducer.userSettings.admin_panel_language]}
                                </UncontrolledTooltip>
                              </>
                            )
                          }
                          <Button
                            className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                            id={`portal-user-${row.original.id}-log-btn`}
                            color='primary'
                            onClick={() => {
                              props.getSelectedLog(row.original.id)
                            }}>
                            <i className="pe-7s-news-paper btn-icon-wrapper" />
                          </Button>
                          <UncontrolledTooltip
                            target={`portal-user-${row.original.id}-log-btn`}
                            placement="top">
                            {Lang['LOG'][props.data.languageReducer.userSettings.admin_panel_language]}
                          </UncontrolledTooltip>
                          <Button
                            className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                            color='primary'
                            id={`portal-user-${row.original.id}-logmein-btn`}
                            onClick={() => {
                              let url = (
                                _.find(
                                  props.data.selectCenterReducer.selectedCenter.center?.domains || [],
                                  { is_default_domain: true }
                                )?.site_domain ||
                                ''
                              )
                              if (!_.isEmpty(url)) {
                                window.open(`https://${url}/portal/login/${row.original.bearer_token}`)
                              }
                            }}>
                            <i className="pe-7s-key btn-icon-wrapper" />
                          </Button>
                          <UncontrolledTooltip
                            target={`portal-user-${row.original.id}-logmein-btn`}
                            placement="top">
                            {Lang['LOG_ME_IN_AS'][props.data.languageReducer.userSettings.admin_panel_language]}
                          </UncontrolledTooltip>
                          <Button
                            className="mb-2 mr-2 mt-2 btn-icon btn-icon-only"
                            color='primary'
                            id={`portal-user-${row.original.id}-upload-btn`}
                            onClick={() => {
                              props.onChangePortalUsersHOC('showUploadModal', true)
                              props.onChangePortalUsersHOC('selectedPortalUsers', row.original)
                            }}
                          >
                            <i className="pe-7s-cloud-upload btn-icon-wrapper" />
                          </Button>
                          <UncontrolledTooltip
                            target={`portal-user-${row.original.id}-upload-btn`}
                            placement="top">
                            {Lang['UPLOAD'][props.data.languageReducer.userSettings.admin_panel_language]}
                          </UncontrolledTooltip>
                        </div>
                      )
                    }
                  ]}
                />
                {
                  !props.isShowingAll && (
                    <CustomPagination
                      meta={props.portalUsersMeta}
                      onChangePage={val => {
                        props.getPortalUsers({
                          ...props.query,
                          page: val,
                        })
                      }}
                    />
                  )
                }
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactCSSTransitionGroup>
      {renderLogModal()}
      {renderMediaModal()}
      {renderBookingModal()}
      {renderUploadContentModal()}
      {renderCreatePortalUsersForm()}
      {renderUpdatePortalUsersForm()}
      {props.onLoadPortalUsersHOC && <LoadingOverlay />}
    </>
  )
}

export default PortalUsersHOC(PortalUsers)
